import baseTheme from "@/themes/baseTheme";
import styled from "styled-components";

export const Wrapper = styled.div`
  min-height: 100vh;
  background-color: #f1f4f6;
  height: auto;
`;

export const TextWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-size: 5em;
  font-weight: 700;
  color: ${baseTheme.token.colorPrimary};
`;

export const Subtitle = styled.div`
  font-size: 40px;
  font-weight: 700;
  color: #1fa9d6;
`;

export const Message = styled.div`
  font-size: 18px;
  text-align: center;
  margin: 30px;
  padding: 20px;
  color: black;
`;
